module ConfigService {
    export interface IConfigService {
        setBaseServicesUrl: (baseServicesUrl: string) => void;
        setActiveTemplate: (templateKey: string, templateValue: string) => void;
        setService: (serviceKey: string, serviceValue: string) => void;
        resolveServiceUrl: (serviceKey: string) => string;
        setAdClientId: (adClientId: string) => void;
        getAdClientId: () => string;
        setSkipPhaseGroupsIfOnlyOne: (skip: boolean) => void;
        isSkipPhaseGroupsIfOnlyOne: () => boolean;
    };

    export interface IConfigData {
        baseServicesUrl: string;
        fullscreenStart: boolean;
        templates: { [key: string]: string };
        services: { [key: string]: string };
        adClientId: string;
        skipPhaseGroupsIfOnlyOne: boolean;
        editBom: boolean;
        loadProdFromProductionLine: boolean;
        hasRfid: boolean;
    };

    export class CConfigService implements IConfigService {
        constructor(
            protected $sessionStorage: any,
            protected $timeout: angular.ITimeoutService,
            protected $translate: angular.translate.ITranslateService,
            protected GlobalApplicationData: any,
            protected jwtHelper: any,
            protected $resource: ng.resource.IResourceService,
            protected $q: angular.IQService,
            protected $http: ng.IHttpService
        ) {
            this.$sessionStorage.isConfigServiceInitialized = false;

            $sessionStorage.configData = <IConfigData>{
                templates: {},
                services: {}
            };
        };

        public init = (forceReload: boolean = false): Promise<void> => {
            if (!forceReload && this.$sessionStorage.isConfigServiceInitialized) {
                return <Promise<void>>this.$q.resolve();
            }

            let _self = this;
            let responseText;

            //TODO CONFIGGURAZIONE INSERITA SU GLOBALAPPLICATON DATA
            if(_self.GlobalApplicationData.token){
            	localStorage.setItem("token", _self.GlobalApplicationData.token);
            	localStorage.setItem("clientId", _self.GlobalApplicationData.ad_client_id);
            }

            if (localStorage.getItem("token")) {
                console.log("token found");
                let xhr = new XMLHttpRequest();
                xhr.open("GET", _self.GlobalApplicationData.applicationContext + "project/getConfig", false);
                xhr.setRequestHeader("Authorization", "Bearer " + localStorage.getItem("token"));
                xhr.setRequestHeader("ad_client_id", localStorage.getItem("clientId"));
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.send();
                let responseStatus = xhr.status;
                if (responseStatus != 200) {
                    localStorage.removeItem("token");
                    window.location.reload();
                }
                console.log("xhr config.json response status:", responseStatus);
                responseText = xhr.responseText;
                console.log("xhr config.json response text:", responseText);
                localStorage.setItem("config", responseText);
                if (responseText) {
                    let configData = <IConfigData>JSON.parse(responseText);

                    if (configData.templates) {
                        for (let activeTemplateKey in configData.templates) {
                            _self.setActiveTemplate(activeTemplateKey, configData.templates[activeTemplateKey]);
                        }
                    }

                    if (configData.baseServicesUrl) {
                        _self.setBaseServicesUrl(configData.baseServicesUrl);
                    }
                    if (configData.services) {
                        for (let serviceKey in configData.services) {
                            _self.setService(serviceKey, configData.services[serviceKey]);
                        }
                    }
                    if (configData.adClientId) {
                        _self.setAdClientId(configData.adClientId);
                    }
                    if (configData.editBom) {
                        _self.setEditBom(configData.editBom);
                    }
                    if (configData.hasRfid) {
                        _self.setHasRfid(configData.hasRfid);
                    }
                    if (configData.loadProdFromProductionLine) {
                        _self.setLoadProdFromProductionLine(configData.loadProdFromProductionLine);
                    }
                    if (configData.fullscreenStart) {
                        console.log("fullscreen", configData.fullscreenStart);
                        _self.setFullscreenStart(configData.fullscreenStart);
                    }
                    _self.setSkipPhaseGroupsIfOnlyOne(!!configData.skipPhaseGroupsIfOnlyOne);



                } else {
                    console.error("error on config.json response");
                }
            } else {
                this.loadDefaultData();
            }

        };

        public setBaseServicesUrl = (baseServicesUrl: string): void => {
             this.$sessionStorage.configData.baseServicesUrl = baseServicesUrl;
        };

        public setActiveTemplate = (templateKey: string, templateValue: string): void => {
            this.$sessionStorage.configData.templates[templateKey] = templateValue;
        };

        public getActiveTemplate = (templateKey: string): string => {
            return this.$sessionStorage.configData.templates ? this.$sessionStorage.configData.templates[templateKey] : null;
        };

        public getFullscreenStart = (): boolean => {
            return this.$sessionStorage.configData.fullscreenStart;
        }

        public setService = (serviceKey: string, serviceValue: string): void => {
            this.$sessionStorage.configData.services[serviceKey] = serviceValue;
        };

        public getEditBom = (): boolean => {
            return this.$sessionStorage.configData.editBom ? this.$sessionStorage.configData.editBom : false;
        };

        public setEditBom = (editBom: boolean): void => {
            this.$sessionStorage.configData.editBom = editBom;
        };
        public getHasRfid = (): boolean => {
            return this.$sessionStorage.configData.hasRfid ? this.$sessionStorage.configData.hasRfid : false;
        };

        public setHasRfid = (hasRfid: boolean): void => {
            this.$sessionStorage.configData.hasRfid = hasRfid;
        };
        public getLoadProdFromProductionLine = (): boolean => {
            return this.$sessionStorage.configData.loadProdFromProductionLine ? this.$sessionStorage.configData.loadProdFromProductionLine : false;
        };

        public setLoadProdFromProductionLine = (loadProdFromProductionLine: boolean): void => {
            this.$sessionStorage.configData.loadProdFromProductionLine = loadProdFromProductionLine;
        };

        public resolveServiceUrl = (serviceKey: string): string => {
            let serviceUrl = this.$sessionStorage.configData.baseServicesUrl;

            if (serviceUrl.substr(serviceUrl.length - 1) !== "/") {
                serviceUrl += "/";
            }

            let serviceValue = this.$sessionStorage.configData.services[serviceKey];
            if (serviceValue) {
                if (serviceValue.substr(0, 1) === "/") {
                    serviceValue = serviceValue.substr(1);
                }
                serviceUrl += serviceValue;
            } else {
                throw new Error("service key not found on services -- " + serviceKey);
            }

            return serviceUrl;
        };

        public setAdClientId = (adClientId: string): void => {
            this.$sessionStorage.configData.adClientId = adClientId;
        };

        public setFullscreenStart = (fullscreenStart: boolean): void => {
            this.$sessionStorage.configData.fullscreenStart = fullscreenStart;
        }

        public getAdClientId = (): string => {
            return this.$sessionStorage.configData.adClientId;
        };

        public setSkipPhaseGroupsIfOnlyOne = (skip: boolean): void => {
            this.$sessionStorage.configData.skipPhaseGroupsIfOnlyOne = skip;
        };

        public isSkipPhaseGroupsIfOnlyOne = (): boolean => {
            return this.$sessionStorage.configData.skipPhaseGroupsIfOnlyOne;
        };

        private loadDefaultData = (): void => {
            this.$sessionStorage.configData = <IConfigData>{
                baseServicesUrl: this.GlobalApplicationData.baseServicesUrl,
                templates: {
                    "login": "tablet-login",
                    "customer": "card-project-lines",
                    "phase-group": "card-phase-group",
                    "phase": "card-phase",
                    "phase-details": "dialog-details",
                    "phase-attachments": "dialog-attachments",
                    "phase-notes": "dialog-notes",
                    "phase-bom": "dialog-bom",
                    "fast-dial": "fast-dial"
                },
                services: {
                    "getConfig": "/rest",
                    "client-login": "/rest/service/ademes/authentication/clientLogin",
                    "operators": "/rest",
                    "login": "/rest",
                    "logout": "/rest",
                    "order-cans": "/rest",
                    "date-grouped-phases": "/rest",
                    "customers": "/rest",
                    "projects": "/rest",
                    "project-lines": "/rest",
                    "phases": "/rest",
                    "save-phase": "/rest",
                    "notes": "/rest",
                    "add-note": "/rest",
                    "phase-group-attachments": "/rest",
                    "phase-attachments": "/rest",
                    "phase-technical-data": "/rest",
                    "phase-start": "/rest",
                    "phase-stop": "/rest",
                    "phase-increase": "/rest",
                    "phase-decrease": "/rest",
                    "phase-bom": "/rest",
                    "phase-component-upload": "/rest",
                    "reports": "/rest",
                    "report-details": "/rest",
                    "activerfid": "/rest",
                    "activephase": "/rest"
                },
                adClientId: null,
                skipPhaseGroupsIfOnlyOne: true,
                fullscreenStart: false,
                editBom: false,
                loadProdFromProductionLine: true,
                hasRfid: false
            };
        };
    };

    // registro la factory
    angular.module("AdeMesApp").factory("ConfigService", ($sessionStorage: any, $timeout: angular.ITimeoutService, $translate: angular.translate.ITranslateService, GlobalApplicationData: any, jwtHelper: any, $resource: ng.resource.IResourceService, $q: angular.IQService, $http: ng.IHttpService) => new ConfigService.CConfigService($sessionStorage, $timeout, $translate, GlobalApplicationData, jwtHelper, $resource, $q, $http));
}
